import { createSlice } from "@reduxjs/toolkit";
import DeleteElementById from "./DeleteElementById.js";
import GetElementById from "./GetElementById.js";

const builder = createSlice({
    name: "builder",
    initialState: {
        variables: {},
        structure: [],
    },
    reducers: {
        setEdit: (state, action) => {
            state.edit = action.payload;
        },

        setHost: (state, action) => {
            state.host = action.payload;
        },

        setVariables: (state, action) => {
            state.variables = action.payload;
        },

        updVariables: (state, action) => {
            state.variables = { ...state.variables, ...action.payload };
        },

        addElement: (state, action) => {
            // parent - id (elements.props.id) or null - to structure
            // element - object of element
            const parent = action.payload.parent;
            const element = action.payload.element;

            if (parent) {
                const _parent = GetElementById(parent, state.structure);
                if (!_parent) {
                    throw new Error(`Not found element by key (parent): ${parent}`);
                } else {
                    (_parent.children = _parent.children ?? []).push(element);
                }
            } else {
                state.structure.push(element);
            }

            state.structure = [...state.structure];
        },

        deleteElement: (state, action) => {
            // element - element id (elements.props.id)
            const element = action.payload;
            state.structure = [...DeleteElementById(element, state.structure)];
        },

        setStructure: (state, action) => {
            // elements - simple array of elements
            // list - target list of elements - default structure
            let elements = action.payload;

            state.structure = [...elements];
        },

        setElementProps: (state, action) => {
            // id - element id
            // props - new element props
            const id = action.payload.id;
            const props = action.payload.props;

            const element = GetElementById(id, state.structure);

            if (element) {
                element.props = { id, ...props, id };
                state.structure = [...state.structure];
            }
        },

        addElementProps: (state, action) => {
            // id - element id
            // props - new element props
            const id = action.payload.id;
            const props = action.payload.props;

            const element = GetElementById(id, state.structure);

            if (element) {
                element.props = { id, ...element.props, ...props, id };
                state.structure = [...state.structure];
            }
        },
    },
});

export const {
    setEdit,
    setHost,
    setVariables,
    updVariables,
    addElement,
    deleteElement,
    setStructure,
    setElementProps,
    addElementProps,
} = builder.actions;

export default builder;
